import React, { useState, useEffect } from 'react';
import ImpdsDetails from './ImpdsDetails';
import { CircularProgress } from '@mui/material';

const ImpdsStateOut = ({ month, year, homeState, transName, transComm, onClose }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [detailsData, setDetailsData] = useState(null);
  const [detailsLoading, setDetailsLoading] = useState(false);

  useEffect(() => {
    fetchData();
  }, [month, year, homeState, transName, transComm]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_URL_SIDE}/api/impds/state-out?month=${month}&year=${year}&homeState=${homeState}&status=O&transName=${transName}&transComm=${transComm}`
      );
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error('Error fetching state out data:', error);
    } finally {
      setLoading(false);
    }
  };

  const getTransDetails = async (distCode, stateCode, month, year, status) => {
    try {
      setDetailsLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_URL_SIDE}/api/impds/details?status=${status}&month=${month}&year=${year}&state=${stateCode}&homeState=${homeState}&dist=${distCode}&transName=${transName}&transComm=${transComm}`
      );
      const result = await response.json();
      setDetailsData(result);
      setTimeout(() => {
        const el = document.getElementById('detailsRd');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    } catch (error) {
      console.error('Error fetching transaction details:', error);
    } finally {
      setDetailsLoading(false);
    }
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: "20px" }}>
      <CircularProgress/>
    </div>;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const monthNames = [
    "January","February","March","April","May","June","July",
    "August","September","October","November","December"
  ];
  const monthInt = parseInt(month);

  return (
    <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '40px' }}>
      <div className="tableheader"
        style={{ maxWidth: '900px', padding: '6px', margin: '0 auto', backgroundColor: '#1785CF', color: '#fff' }}>
        {transName} OUT ONORC for the month of {monthNames[monthInt - 1]}-{year}
      </div>
      <div style={{ maxWidth: '900px', overflowX: 'auto', margin: '0 auto' }}>
        <table id="fpsreport" style={{ width: '100%', borderCollapse: 'collapse', margin: 0, padding: 0 }}>
          {data.reportList && data.reportList.length > 0 && data.districtList && data.districtList.length > 0 ? (
            <>
              <thead>
                <tr className="tableheader">
                  <td rowSpan="2" >SL NO.</td>
                  <td rowSpan="2">SALE STATE</td>
                  <td colSpan={data.districtList.length} >HOME DISTRICTS</td>
                </tr>
                <tr className="tableheader">
                  {data.districtList.map((district, index) => (
                    <td key={index} >{district.dist_name_en}</td>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data.reportList.map((report, d) => (
                  <tr key={d}>
                    <td style={bodyCellStyle()}>{d + 1}</td>
                    <td style={bodyCellStyle()}>{report.state_name_en}</td>
                    {data.districtList.map((district, cc) => {
                      const districtCount = report.listd.find(dc => dc.dist_code === district.dist_code);
                      const count = districtCount ? districtCount.out_count : 0;
                      return (
                        <td key={cc} align="right" style={bodyCellStyle()}>
                          {count > 0 ? (
                            <a
                              style={{ cursor: 'pointer' }}
                              onClick={() => getTransDetails(district.dist_code, report.state_code, month, year, 'O')}
                            >
                              {count}
                            </a>
                          ) : count}
                        </td>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr className="tableheader">
                  <td colSpan="2" >Total</td>
                  {data.districtList.map((district, cc) => {
                    const total = data.reportList.reduce((sum, report) => {
                      const districtCount = report.listd.find(dc => dc.dist_code === district.dist_code);
                      return sum + (districtCount ? districtCount.out_count : 0);
                    }, 0);
                    return <td key={cc} align="right" >{total}</td>;
                  })}
                </tr>
              </tfoot>
            </>
          ) : (
            <tbody>
              <tr className="tableheader">
                <td colSpan={(data.districtList ? data.districtList.length : 0) + 2}
                    align="center" >
                  No data found
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      <div align="center" id="loadingRd"
           style={{ display: detailsLoading ? 'block' : 'none', marginTop: '10px' }}>
       <CircularProgress/>
      </div>
      <div id="detailsRd" style={{ marginTop: '18px' }}>
        {detailsData && (
          <ImpdsDetails
            data={detailsData}
            onClose={() => setDetailsData(null)}
          />
        )}
      </div>
    </div>
  );
};


const bodyCellStyle = () => ({
  padding: '6px',
  border: '1px solid #ddd'
});



export default ImpdsStateOut;